module.exports = __webpack_public_path__ + "img/green_125.52c2a7fa.png";